module.exports = __webpack_public_path__ + "static/intro-background-mobile-1e391034a891564d2ae22e7e6f191382.jpg";